import { Injectable } from "@angular/core";
import { catchError, map, of } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { SERVICE_END_POINT } from "src/app/shared/services/api-constants/service-endpoints.constants";
import { CURRENT_ENVIROMENT } from "src/app/shared";
import { ConfigLoaderService } from "./configLoader.service";
@Injectable({ providedIn: 'root' })

export class AddressSearchService {
  constructor(public httpClient: HttpClient, private configLoader: ConfigLoaderService) { }
  readonly endPoints = SERVICE_END_POINT[CURRENT_ENVIROMENT.environment];
  locateKey: string = this.endPoints.locateAPIKey;
  GCD_L1: string = '';
  GCD_L2: string = '';
  GCD_L3: string = '';
  GCD_L4: string = '';

  public searchAddress(searchtext) {
    return this.searchEntries(searchtext).pipe(map((res => {
      return res['Items'];
    })));
  }

  public searchEntries(searchtext) {
    if (searchtext.length === 0) {
      return of([{
        results: [{
          suggestion: '',
          format: ''
        }]
      }]);
    }
    if (CURRENT_ENVIROMENT.environment == 'localEnvironment') {
      return this.httpClient.get<any>(`${this.endPoints.findAddressUrl}`)
        .pipe(map((res: Response) => {
          return res;
        }),
          catchError(err => of([{
            results: [{
              suggestion: 'No record Found',
              format: ''
            }]
          }])));
    }
    return this.httpClient.get<any>(`${this.endPoints.findAddressUrl}=${this.configLoader.configuration.locateApiKey}&Text=${searchtext}&Countries=GB&Type=Address`)
      .pipe(map((res: Response) => {
        return res;
      }),
        catchError(err => of([{
          results: [{
            suggestion: 'No record Found',
            format: ''
          }]
        }])));
  }

  public searchDummyAddress() {
    return this.httpClient.get(this.endPoints.noAddressFound).pipe(map((resdummy) => {
      return resdummy['results'];
    }));
  }

  public getFormattedAddress(addressId) {
    if (CURRENT_ENVIROMENT.environment == 'localEnvironment') {
      return this.httpClient.get<any>(this.endPoints.retrieveAddressUrl).pipe(
        map((res: Response) => res['Items']),
        catchError(err => of([{
          results: [{
            suggestion: 'No record Found',
            format: '',
          },],
        },])))
    }
    const url = `${this.endPoints.retrieveAddressUrl}=${this.configLoader.configuration.locateApiKey}&Id=${addressId}`;
    return this.httpClient.get<any>(url)
      .pipe(map((res: Response) => res['Items']),
        catchError(err => of([{
          results: [{
            suggestion: 'No record Found',
            format: '',
          },],
        },])))
  }

  public mapFormattedAddress(item: any) {
    const line1 = item.Line1?.trim() || '';
    const line2 = item.Line2?.trim() || '';
    const line3 = item.Line3?.trim() || '';
    const line4 = item.Line4?.trim() || '';
    const line5 = item.Line5?.trim() || '';
    const city = item.City?.toUpperCase() || '';
    const postCode = item.PostalCode || '';
    const populatedLines = [line1, line2, line3, line4, line5].filter(line => line !== '').length;
    if (populatedLines === 5) {
      this.mapFiveAddressLines(line1, line2, line3, line4, line5, city);
    } else if (populatedLines === 4) {
      this.mapFourAddressLines(line1, line2, line3, line4, city);
    } else if (populatedLines === 3) {
      this.mapthreeAddressLines(line1, line2, line3, city);
    } else if (populatedLines === 2) {
      this.maptwoAddressLines(line1, line2, city);
    } else if (populatedLines === 1) {
      this.mapOneAddressLines(line1, city);
    }
    return {
      addressLine1: this.GCD_L1,
      addressLine2: this.GCD_L2,
      addressLine3: this.GCD_L3,
      locality: this.GCD_L4,
      postalCode: postCode
    }
  }

  public merge(a: string, b: string) {
    if (!a && !b) return '';
    if (a && !b) return a;
    if (!a && b) return b;
    return `${a}, ${b}`.trim();
  }

  public mapFiveAddressLines(line1, line2, line3, line4, line5, city) {
    this.GCD_L1 = line1;
    this.GCD_L2 = line2;
    const mergedL3 = this.merge(line3, line4);
    if (mergedL3.length <= 35) {
      this.GCD_L3 = mergedL3;
      const mergedL4 = this.merge(line5, city);
      this.GCD_L4 = mergedL4.length <= 35 ? mergedL4 : city;
    } else {
      this.GCD_L3 = line3;
      const mergedL4 = this.merge(line4, city);
      this.GCD_L4 = mergedL4.length <= 35 ? mergedL4 : city;
    }
  }

  public mapFourAddressLines(line1, line2, line3, line4, city) {
    this.GCD_L1 = line1;
    this.GCD_L2 = line2;
    const mergedL3 = this.merge(line3, line4);
    this.GCD_L3 = mergedL3.length <= 35 ? mergedL3 : line3;
    const mergedL4 = mergedL3.length <= 35 ? this.merge(null, city) : this.merge(line4, city);
    this.GCD_L4 = mergedL4.length <= 35 ? mergedL4 : city;
  }

  public mapthreeAddressLines(line1, line2, line3, city) {
    this.GCD_L1 = line1;
    this.GCD_L2 = line2;
    this.GCD_L3 = line3;
    this.GCD_L4 = city;
  }

  public maptwoAddressLines(line1, line2, city) {
    this.GCD_L1 = line1;
    this.GCD_L2 = line2;
    this.GCD_L3 = city;
    this.GCD_L4 = '';
  }

  public mapOneAddressLines(line1, city) {
    this.GCD_L1 = line1;
    this.GCD_L2 = city;
    this.GCD_L3 = '';
    this.GCD_L4 = '';
  }
}